import { render } from "./Deselect.vue?vue&type=template&id=1b74e94c"
const script = {}

import "./Deselect.vue?vue&type=style&index=0&id=1b74e94c&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__